// extracted by mini-css-extract-plugin
export var csatScore = "_nc-5";
export var header = "_nc-1";
export var panelWrapper = "_nc-2";
export var postPreview = "_nc-3";
export var rightContent = "_nc-0";
export var wrappingText = "_nc-4";